const state = {
	items: [],
	paging: {},
	item: {}
}
const mutations = {
	SET_JUNK_LEAD_ITEMS: (state, payload) => {
		state.items = payload.data;
		const pages = Object.assign(payload.pages, payload.items);
		state.paging = Object.assign({}, pages);
	},
}

const actions = {
	setJunkLeadItems({ commit }, payload) {
		commit('SET_JUNK_LEAD_ITEMS', payload)
	},
}

const getters = {
	failedJunkItems: state => state.items,
	failedJunkPaging: state => state.paging,
}

export default {
	state,
	mutations,
	actions,
	getters
}


// WEBPACK FOOTER //
// ./src/store/module/junkLeads.js